import { combineReducers } from '@reduxjs/toolkit'
import AuthBaseApiSlice from '../api/AuthBaseApiSlice'
import { bookingApi } from '../modules/unauthenticated/booking/api/bookingApi'

const rootReducer = combineReducers({
  [AuthBaseApiSlice.reducerPath]: AuthBaseApiSlice.reducer,
  [bookingApi.reducerPath]: bookingApi.reducer
})

export default rootReducer
